import React from 'react';
import { COLORS } from '../../constants';
import './Button.css';

const Button = ({ 
  children, 
  variant = 'primary', 
  onClick, 
  disabled, 
  className = '', 
  style = {},
  fullWidth = true 
}) => {
  const variants = {
    primary: {
      background: COLORS.primary,
      color: 'white',
      boxShadow: '0 4px 15px rgba(0, 198, 137, 0.3)',
    },
    outline: {
      background: 'transparent',
      border: `2px solid ${COLORS.border}`,
      color: COLORS.textMuted,
    },
    activate: {
      background: COLORS.secondary,
      color: 'white',
      boxShadow: '0 4px 15px rgba(2, 6, 23, 0.2)',
    },
    danger: {
      background: COLORS.danger,
      color: 'white',
      boxShadow: '0 4px 15px rgba(239, 68, 68, 0.3)',
    },
  };

  const baseStyle = {
    width: fullWidth ? '100%' : 'auto',
    ...variants[variant],
    ...style,
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`prisma-button ${className}`}
      style={baseStyle}
    >
      {children}
    </button>
  );
};

export default Button;